import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';

const ModalContent = styled('div')`
  display: flex;
  width: 100%;
  height: 70vh;
  overflow: hidden;
  outline: none; 
`;

const Container = styled('div')`
flex: 1;
`;

const VideoModal = ({ url }) => (
  <ModalContent>
    <Container>
      <ReactPlayer
        url={url}
        controls
        width='100%'
        height='100%'
      />
    </Container>
  </ModalContent>
);

VideoModal.propTypes = {
  url: PropTypes.string.isRequired,
};

export default VideoModal;
